<template>
  <div>
    <div class="col align-self-center text-center " v-if="loading">
      <clip-loader />
    </div>
    <div v-else>
      <Article v-for="(article, index) in articles"
        v-bind:key="article.id" v-bind:enhance="!(index % 2)"
        v-bind:article="article.data"/>
    </div>
  </div>
</template>

<script>
import Article from './Article';
import ClipLoader from './ClipLoader';

export default {
  name: 'Articles',
  components: { Article, ClipLoader },
  data() {
    return {
      articles: [],
      loading: true,
    };
  },
  methods: {
    getContent() {
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.tags', ['accueil']), {
          pageSize: 100,
        })
        .then((response) => {
          this.articles = response.results
            .sort((a, b) =>
              a.data.article_date && b.data.article_date &&
              new Date(b.data.article_date).getTime() - new Date(a.data.article_date).getTime());
          this.loading = false;
        });
    },
  },
  created() {
    this.getContent();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Articles.vue